// extracted by mini-css-extract-plugin
module.exports = {"cart-empty":"CartEmptyState_cart-empty__3Jcj0","cart-empty__icon":"CartEmptyState_cart-empty__icon__2e6NZ","cart-empty__message":"CartEmptyState_cart-empty__message__1omxS"};